import React from 'react';
import { motion } from 'framer-motion';
import '../styles/News.css';

const News = () => {
  const newsItems = [
    {
      id: 1,
      date: '1/30/25',
      title: 'Wing and PepsiCo Team Up to Deliver Snacks for the Big Game by Drone',
      image: 'https://storage.googleapis.com/app_darkendimg/openkoffie/b_2.png',
      link: '#'
    },
    {
      id: 2,
      date: '12/18/24',
      title: 'Drone delivery set to launch at Brookfield Properties Dallas-Fort Worth malls in partnership with DoorDash',
      image: 'https://storage.googleapis.com/app_darkendimg/openkoffie/owner4.png',
      link: '#'
    },
    {
      id: 3,
      date: '11/13/24',
      title: 'NHS blood sample analysis now expedited by on-demand drone delivery service',
      image: 'https://storage.googleapis.com/app_darkendimg/openkoffie/roaster4.png',
      link: '#'
    },
    {
      id: 4,
      date: '10/3/24',
      title: '1 year and 26 cities later: Celebrating our DFW growth',
      image: 'https://storage.googleapis.com/app_darkendimg/openkoffie/wheelofflavor.png',
      link: '#'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <section className="news-section" id="news">
      <div className="container">
        <motion.div 
          className="section-header text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <a href="#news" className="section-link">News</a>
          <h2 className="news-title">Read more stories</h2>
        </motion.div>

        <motion.div 
          className="news-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {newsItems.map((item) => (
            <motion.div 
              key={item.id} 
              className="news-card"
              variants={itemVariants}
            >
              <a href={item.link} className="news-link">
                <div className="news-image" style={{ backgroundImage: `url(${item.image})` }}>
                  <div className="news-date">{item.date}</div>
                </div>
                <h3 className="news-card-title">{item.title}</h3>
              </a>
            </motion.div>
          ))}
        </motion.div>

        <motion.div 
          className="cta-container text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          <a href="#blog" className="btn btn-secondary">Visit the blog</a>
        </motion.div>
      </div>
    </section>
  );
};

export default News;
